<template>
  <div class="ma-2" ref="tmosSimulator">
    <v-card elevation="2" class="pb-2">
      <component
        v-if="tmoSimulatorFormInput"
        :is="tmoStimulatorFormMetaData.componentName"
        :ref="tmoStimulatorFormMetaData.myRefName"
        :value="selectModel(tmoSimulatorFormInput)"
        @input="
          (newValue) => updateModel(tmoSimulatorFormInput, newValue, undefined)
        "
        v-bind="tmoStimulatorFormMetaData.props"
      ></component>

      <component
        :is="tmoStimulatorMDP.componentName"
        :ref="tmoStimulatorMDP.myRefName"
        :value="selectModel(tmoSimulatorFormInput)"
        @input="
          (newValue) => updateModel(tmoSimulatorFormInput, newValue, result)
        "
        v-bind="tmoStimulatorMDP.props"
      ></component>

      <v-alert v-if="isOutstandingChanged()" color="warning" outlined>
        Total outstanding has changed.Please recalculate
      </v-alert>

      <div class="d-flex flex-column justify-center align-center">
        <div class="d-flex align-center mb-5">
          <v-chip
            v-if="paymentPlanDetails.isMSFSubscriptionAvailable"
            class="mr-2"
            color="black"
            label
            outlined
            >MSF: &nbsp;&nbsp;<span class="font-weight-bold secondary--text"
              >{{ computedResult.msfAmount | toINR }} -
              {{
                modelValue.paymentPlan.ppCalculator.msfDiscountAmount | toINR
              }}
              (Discount) = {{ msfAmountAfterDiscount | toINR }}</span
            >
          </v-chip>
          <v-chip v-else class="mr-2" color="black" label outlined>
            OnboardingFee: &nbsp;&nbsp;<span
              class="font-weight-bold primary--text"
            >
              {{ computedResult.msfAmount | toINR }}
            </span>
          </v-chip>
        </div>
        <div class="d-flex align-center mb-5">
          <v-chip class="mx-2" color="black" label outlined>
            Repayment to Creditor:&nbsp;&nbsp;<span
              class="font-weight-bold primary--text"
              >{{ Math.round(actualRepaymentToCred) | toINR }}</span
            >
          </v-chip>
          <v-icon>mdi-plus-thick</v-icon>
          <v-chip class="mx-2" color="black" label outlined>
            FREED Fee:&nbsp;&nbsp;<span
              class="font-weight-bold primary--text"
              >{{ Math.round(freedFee) | toINR }}</span
            >
          </v-chip>
          <v-icon>mdi-equal</v-icon>

          <v-chip class="mx-2" color="black" label outlined>
            Total Repayment Amount:&nbsp;&nbsp;<span
              class="font-weight-bold primary--text"
              >{{ Math.ceil(repaymentAmount) | toINR }}</span
            >
          </v-chip>
        </div>
      </div>

      <v-alert
        v-if="isRecalculationNotAllowed()"
        color="warning"
        outlined
        icon="mdi-alert"
        >Please connect with your manager for enabling higher tenure</v-alert
      >

      <v-alert
        dense
        type="warning"
        outlined
        class="col-5 ma-auto mb-5"
        v-if="
          modelValue.paymentPlan?.ppCalculator.totalMonthlyObligation >
          modelValue.budgetInfo.proposedDSPayment
        "
      >
        Monthly Obligation ({{
          modelValue?.paymentPlan?.ppCalculator.totalMonthlyObligation.toFixed(
            2
          ) | toINR
        }}) greater than Affordability ({{
          modelValue?.budgetInfo?.proposedDSPayment.toFixed(2) | toINR
        }}).
      </v-alert>
    </v-card>
  </div>
</template>
<script lang="ts">
import { Component, Prop, Watch } from "vue-property-decorator";
import { VBtn } from "vuetify/lib/components";
import * as Data from "@/../src-gen/data";

import store, * as Store from "@/../src-gen/store";

import TMOStimulatorFFormMDP from "./TMOStimulatorFFormMDP";
import moment from "moment";
import TMOStimulatorMDP from "./TMOStimulatorMDP";
import * as Action from "@/../src-gen/action";
import FSnackbar from "@/fsnackbar";
import ModelVue from "@/components/ModelVue";
import FCurrencyField from "@/components/form/field/FCurrencyField.vue";
import FNumberField from "@/components/form/field/FNumberField.vue";
import FDateSelectField from "@/components/form/field/FDateSelectField.vue";
import FForm from "@/components/form/FForm.vue";
import Task from "@/util/Task";
import Helper from "@/util/Helper";
import PPHelper from "@/section/affiliateapp/utils/PPHelper";

@Component({
  components: {
    FCurrencyField,
    FNumberField,
    FDateSelectField,
    FForm,
  },
})
export default class TMOStimulatorFForm extends ModelVue {
  @Store.Getter.ClientFile.ClientFileSummary.fileSummary
  fileSummary: Data.ClientFile.FileSummary;

  @Store.Getter.TaskList.Summary.executiveTaskDetails
  taskDetails: Data.TaskList.ExecutiveTaskDetails;

  @Store.Getter.ClientFile.ClientFileSummary.fiPaymentPlanInfo
  fiPaymentPlanInfo: Data.ClientFile.FiPaymentPlanInfo;

  @Store.Getter.Login.LoginDetails.roleList
  roleList: string[];
  @Store.Getter.Payment.PaymentStore.msfSlabList
  msfSlabList: Data.Payment.MSFSlab[];
  @Store.Getter.Payment.PaymentStore.planDetails
  planDetails: Data.Payment.PlanDetails;

  @Store.Getter.Payment.PaymentStore.paymentPlanDetails
  paymentPlanDetails: Data.Payment.PaymentPlanDetails;

  editMode: boolean = false;
  clientFileId = this.$route.params.clientFileId;
  tmoSimulatorFormInputLocal: {
    outstanding: number;
    settlementPercentage: number;
    affordability: number;
    firstSPADraftDate: string;
    selectedDraftDay: number;
    // monthlyPayment: number;
    tenure: number;
    serviceFeeWithGST?: number;
  } | null = null;

  tmosComputedResult: any = {};
  serviceFeePercentageWithGST(serviceFeePercentageWithoutGST: number) {
    const gstOnServiceFee = (serviceFeePercentageWithoutGST * 18) / 100;
    return gstOnServiceFee + serviceFeePercentageWithoutGST;
    // return 17.7
  }

  get feeGstPercentage() {
    console.log(
      this.tmoSimulatorFormInput?.serviceFeePercentageWithoutGST || 15,
      "this.tmoSimulatorFormInput?.serviceFeePercentageWithoutGST||0"
    );
    const feeGstPercentage = this.serviceFeePercentageWithGST(
      this.tmoSimulatorFormInput?.serviceFeePercentageWithoutGST ||
        this.paymentPlanDetails.planDetails.serviceFeePercentage ||
        15
    );
    return feeGstPercentage;
  }

  get totalPercentage() {
    return (
      (this.tmoSimulatorFormInputLocal?.settlementPercentage || 45) +
      this.feeGstPercentage
    );
  }

  //Problematic
  getRepaymentAmount() {
    return (
      ((this.tmoSimulatorFormInputLocal?.outstanding || 0) *
        this.totalPercentage) /
      100
    );
    // return this.totalPercentage;
  }

  get repaymentAmount() {
    return this.getRepaymentAmount();
  }

  get tenure() {
    return 1;
  }

  get freedFee() {
    return (
      (this.tmoSimulatorFormInput.outstanding * this.feeGstPercentage) / 100
    );
  }

  get actualRepaymentToCred() {
    return (
      (this.tmoSimulatorFormInput.outstanding *
        this.tmoSimulatorFormInput.settlementPercentage) /
      100
    );
  }
  get computedResult() {
    console.log("Encountered computed");
    const msfDiscountAmount =
      this.modelValue?.paymentPlan?.ppCalculator?.msfDiscountAmount || 0;
    const outstanding = this.tmoSimulatorFormInputLocal?.outstanding || 0;
    // const monthlyPayment = this.tmoSimulatorFormInputLocal?.monthlyPayment || 0;
    const monthlyPayment = Math.ceil(
      this.repaymentAmount / this.tmoSimulatorFormInput?.tenure || 0
    );

    const msfAmount = this.getFeeSlabWithFreed(outstanding);
    const monthlyObligation = this.paymentPlanDetails.isMSFSubscriptionAvailable
      ? monthlyPayment + msfAmount - msfDiscountAmount
      : monthlyPayment;
    return {
      msfDiscountAmount:
        this.modelValue?.paymentPlan?.ppCalculator?.msfDiscountAmount || 0,
      tenureApproval: this.modelValue.maxTenure,
      msfAmount: msfAmount,
      monthlyObligation,
    };
  }

  get tmoSimulatorFormInput() {
    this.tmoSimulatorFormInputLocal = {
      affordability: this.modelValue.budgetInfo?.proposedDSPayment || 0,
      firstSPADraftDate:
        this.modelValue.paymentPlan?.ppCalculator?.firstDraftDate ||
        moment().add(2, "days").format(Helper.DATE_FORMAT),
      // monthlyPayment:
      //   this.modelValue.paymentPlan?.ppCalculator?.spaDraftAmount || 0,
      tenure:
        this.modelValue?.paymentPlan.ppCalculator?.tenor !== 0
          ? this.modelValue?.paymentPlan.ppCalculator?.tenor
          : this.modelValue?.maxTenure || 6,
      outstanding: this.modelValue.creditorInfo?.totalDebt,
      selectedDraftDay:
        this.modelValue.paymentPlan?.ppCalculator?.selectedDraftDay,
      settlementPercentage:
        this.modelValue.paymentPlan?.ppCalculator?.settlementPercentage || 45,
    };
    return this.tmoSimulatorFormInputLocal;
  }

  set tmoSimulatorFormInput(newVal: any) {
    this.tmoSimulatorFormInputLocal = newVal;
  }

  //METADATA
  get tmoStimulatorFormMetaData() {
    return new TMOStimulatorFFormMDP({
      taskRoot: this,
    }).getMetaData();
  }
  getMSFWithFreed(amount: number) {
    return this.msfSlabList.reduce((acc, curItem) => {
      if (amount > curItem.minGreater && amount <= curItem.maxLessEquals) {
        acc = curItem.feeAmount;
      }
      return acc;
    }, 0);
  }

  handleEditClick() {
    this.editMode = true;
  }

  handleCancelEditClick() {
    this.editMode = false;
    // this.result.tenure = this.modelValue?.paymentPlan.ppCalculator?.tenor;
    this.tmoSimulatorFormInput.settlementPercentage =
      this.modelValue?.paymentPlan.ppCalculator?.settlementPercentage;
    this.tmoSimulatorFormInput.selectedDraftDay =
      this.modelValue?.paymentPlan.ppCalculator?.selectedDraftDay;
    this.tmoSimulatorFormInput.monthlyPayment =
      this.modelValue.paymentPlan?.ppCalculator?.spaDraftAmount || 0;
    this.tmoSimulatorFormInput.tenure =
      this.modelValue?.paymentPlan.ppCalculator?.tenor !== 0
        ? this.modelValue?.paymentPlan.ppCalculator?.tenor
        : this.modelValue?.maxTenure || 6;
  }

  get taskDisabled(): boolean {
    return Task.isTaskNotActionable(
      this.taskDetails.taskState,
      this.taskDetails.isSuspended
    );
  }

  get tenureLessGreaterThanEqual() {
    return this.tmoSimulatorFormInput?.tenure > this.modelValue.maxTenure;
  }

  isRecalculationNotAllowed(): boolean {
    return (
      (this.isSalesRep || this.isSalesLead) && this.tenureLessGreaterThanEqual
    );
  }

  get isSalesRep() {
    return this.roleList.includes("SalesRep");
  }

  get isSalesLead() {
    return this.roleList.includes("SalesLead");
  }

  get msfAmountAfterDiscount() {
    return (
      (this.computedResult.msfAmount || 0) -
      (this.modelValue?.paymentPlan?.ppCalculator?.msfDiscountAmount || 0)
    );
  }

  get tmoStimulatorMDP() {
    return new TMOStimulatorMDP({
      taskRoot: this,
    }).getMetaData();
  }

  scheduleorDraftPaymentPlan() {
    if (this.isPaymentPlanDataAvailable()) {
      this.schedulePaymentPlan();
    } else {
      this.draftPaymentPlan();
    }
  }

  schedulePaymentPlan() {
    const input: Data.Payment.RecalculatePSPlanInput =
      Data.Payment.RecalculatePSPlanInput.fromJson(this.modelValue.paymentPlan);
    input.psPlanId = this.modelValue.paymentPlan.psPlanId;
    input.tmoAmount = Math.round(this.computedResult.monthlyObligation || 0);
    input.selectedDraftDay = this.tmoSimulatorFormInput.selectedDraftDay;

    Action.Payment.RecalculatePSPlan.execute(input, (output: any) => {
      FSnackbar.success("Succesfully Saved");
      this.editMode = false;
    });
  }

  isFormDirty(): boolean {
    return (
      this.modelValue?.paymentPlan.ppCalculator?.tenor !== this.tenure ||
      this.modelValue?.paymentPlan.ppCalculator?.settlementPercentage !==
        this.tmoSimulatorFormInput.settlementPercentage ||
      this.modelValue?.paymentPlan.ppCalculator?.selectedDraftDay !==
        this.tmoSimulatorFormInput.selectedDraftDay
    );
  }

  draftPaymentPlan() {
    const input: Data.Payment.DraftPSPlanInput =
      new Data.Payment.DraftPSPlanInput();
    input.clientFileId = this.clientFileId;
    input.spaAmount = Math.round(this.computedResult.monthlyObligation || 0);

    input.selectedDraftDay = this.tmoSimulatorFormInput.selectedDraftDay;
    Action.Payment.DraftPSPlan.execute(input, (output) => {
      this.editMode = false;
    });
  }

  isOutstandingChanged() {
    return (
      this.tmoSimulatorFormInput?.outstanding !==
      this.modelValue?.paymentPlan?.ppCalculator?.outstanding
    );
  }

  isMSFValueNegative() {
    return this.computedResult.msfAmount < 0;
  }

  isPaymentPlanDataAvailable() {
    return this.modelValue.paymentPlan?.psPlanId !== "";
  }

  getFeeSlabWithFreed(amount: number) {
    const slabList = this.paymentPlanDetails.isMSFSubscriptionAvailable
      ? this.paymentPlanDetails.msfSlabList
      : this.paymentPlanDetails.onboardingFeeSlabList;
    return PPHelper.getFeeSlab(slabList, amount);
  }
}

export interface ComputedResult {}
</script>
